const SECRET_LENGTH = 32;

export function generateAdminSecretCode() {
  const bytes = new Uint8Array(SECRET_LENGTH / 2);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
